import "./styles/footer.css";
import logo from "../images/Round-logo.webp";
import facebook from "../images/sm/facebook.webp";
import insta from "../images/sm/instagram.webp";
import tiktok from "../images/sm/tiktok.webp";
import youtube from "../images/sm/youtube.webp";
import twitter from "../images/sm/TWITTER_TRANSPARENT.png";
import tuckshop from "../images/tuckshop_logo.webp";
import { Link } from "react-router-dom";

const socialLinks = [
  { name: "Facebook", image: facebook, url: "https://www.facebook.com/tubbees.desserts/" },
  { name: "Instagram", image: insta, url: "https://www.instagram.com/tubbees.desserts/" },
  { name: "TikTok", image: tiktok, url: "https://www.tiktok.com/@tubbees.desserts/" },
  { name: "X (Twitter)", image: twitter, url: "https://twitter.com/tubbeesdesserts" },
  { name: "YouTube", image: youtube, url: "https://www.youtube.com/channel/UCxQ_Bi2J2P2OZWEYTBQhXtg" },
];

export default function Footer() {
  return (
    <footer id="footer" aria-label="Site footer">
      <div className="footer__inner">
        <div className="footer__intro">
          <div>
            <p className="footer__eyebrow">A little more happy</p>
            <h2>Life's sweeter<br />with Tubbees.</h2>
          </div>
          <Link className="footer__cta" to="/find-us">
            Find your nearest Tubbees <span aria-hidden="true">↗</span>
          </Link>
        </div>

        <div className="footer__grid">
          <div className="footer__brand">
            <Link to="/" aria-label="Tubbees home">
              <img src={logo} alt="Tubbees" className="footer__logo" width="112" height="112" loading="lazy" />
            </Link>
            <p>Big flavours. Sweet moments.<br />A whole lot of Tubbees.</p>
          </div>

          <nav className="footer__col" aria-label="Explore Tubbees">
            <h3>Explore</h3>
            <Link to="/menu">Our menu</Link>
            <Link to="/slushees">Slushees</Link>
            <Link to="/app">Get the app</Link>
          </nav>

          <div className="footer__col">
            <nav aria-label="Join Tubbees">
              <h3>Join the fun</h3>
              <Link to="/apply">Join the team <span aria-hidden="true">↗</span></Link>
              <Link to="/partner">Tubbees Express <span aria-hidden="true">↗</span></Link>
            </nav>
            <p className="footer__social-label">Your daily dose of sweet</p>
            <div className="footer__social">
              {socialLinks.map(({ name, image, url }) => (
                <a key={name} href={url} target="_blank" rel="noopener noreferrer" aria-label={`${name} (opens in a new tab)`}>
                  <img src={image} alt="" width="20" height="20" loading="lazy" />
                </a>
              ))}
            </div>
          </div>

          <a className="footer__shop" href="https://shop.tubbees.co.uk" target="_blank" rel="noopener noreferrer" aria-label="Visit Tubbees Tuck Shop (opens in a new tab)">
            <span className="footer__shop-label">The sweet stuff, delivered</span>
            <img src={tuckshop} alt="Tubbees Tuck Shop" loading="lazy" />
            <span className="footer__shop-link">Visit the Tuck Shop <span aria-hidden="true">↗</span></span>
          </a>
        </div>

        <div className="footer__copy">
          <span>&copy; {new Date().getFullYear()} Tubbees. All rights reserved.</span>
          <p>Website Designed &amp; Developed by <a href="https://nitrosolutions.co.uk/">Nitro Solutions</a></p>
        </div>
      </div>
    </footer>
  );
}
